import styles from './UnsupportedBrowserScreen.module.scss';
import { IconUnsupportedBrowser, MBLogo } from '../../icons/Icons';
import language from '../../util/language';
import { ELinks } from '../../util/constants';
import { EUnsupportedReason } from '../../util/constants';
import { Link } from '@mui/material';
import { FC } from 'react';

export type TUnsupportedScreenProps = {
    reason?: EUnsupportedReason;
};

const UnsupportedBrowserScreen: FC<TUnsupportedScreenProps> = (props) => {
    const currentYear = new Date().getFullYear();

    let headerText = 'Unsupported';
    let descText = 'Unsupported';
    let browserList = null;

    if (props.reason === EUnsupportedReason.unsupportedBrowser) {
        headerText = language.unsupported.unsupportedBrowser.header;
        descText = language.unsupported.unsupportedBrowser.desc;
        browserList = (
            <ul>
                <li>{language.unsupported.unsupportedBrowser.chrome}</li>
                <li>{language.unsupported.unsupportedBrowser.firefox}</li>
                <li>{language.unsupported.unsupportedBrowser.edge}</li>
                <li>{language.unsupported.unsupportedBrowser.safari}</li>
            </ul>
        );
    } else if (props.reason === EUnsupportedReason.cookiesDisabled) {
        headerText = language.unsupported.cookiesDisabled.header;
        descText = language.unsupported.cookiesDisabled.desc;
    }

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.icon}>
                    <IconUnsupportedBrowser />
                </div>
                <h1>{headerText}</h1>
                <p>{descText}</p>
                {browserList}
            </div>
            <footer className={styles.footer}>
                <span className={styles.footerLogo}>
                    <MBLogo width={'105'} height={'21'} fillColor={'#696C74'} />
                </span>
                <p
                    className={styles.copyright}
                    data-testid="current-year"
                >{`Copyright \u00A9${currentYear} Mindbody, Inc.`}</p>
                <p className={styles.footerLinks}>
                    <Link href={ELinks.privacyPolicy} target="_blank" rel="noreferrer" data-testid="legal-privacy">
                        {`${language.legal.privacyPolicy} ${language.common.and} ${language.legal.privacyRights}`}
                    </Link>
                    <span className={styles.delimiter}>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                    <Link href={ELinks.termsServiceConsumer} target="_blank" rel="noreferrer" data-testid="legal-terms">
                        {language.legal.termsUse}
                    </Link>
                </p>
            </footer>
        </div>
    );
};

export default UnsupportedBrowserScreen;
